// extracted by mini-css-extract-plugin
module.exports = {"parentRow":"NewPlanFactVolumeSection_parentRow__11IKJ","parentName":"NewPlanFactVolumeSection_parentName__2pvJB","right":"NewPlanFactVolumeSection_right__PFApq"};